import "./index.scss";

import { MenuItem, Pagination as MUIPagination, PaginationItem, Stack } from "@mui/material";
import Dropdown, { DropdownProps } from "components/Dropdown";
import { TPagination } from "modules/api/type";
import { FC } from "react";

export const PAGE_OPTIONS = [10, 25, 50, 100];

export interface PaginationProps extends TPagination {
  perPageOptions?: number[];
  pageDropdownProps?: DropdownProps;
  onPageChange: Function;
  current_page: number;
  total_pages: number;
  containerStyle?: object;
}

const Pagination: FC<PaginationProps> = (props) => {
  const {
    perPageOptions = PAGE_OPTIONS,
    pageDropdownProps,
    current_page,
    total_pages,
    onPageChange,
    containerStyle = {},
  } = props;

  const page = current_page;
  const pageCount = total_pages;

  return (
    <Stack
      width="100%"
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      marginTop="30px"
      style={containerStyle}
    >
      <Stack flex={1} direction="row" alignItems="center" spacing={2}>
        <h3 className="h3 regular-secondary ">Per page</h3>
        <Dropdown
          label="Member Set"
          className="per-page-dropdown"
          showLabel={false}
          {...pageDropdownProps}
        >
          {perPageOptions
            .map((v) => {
              return {
                label: `${v}`,
                value: v,
              };
            })
            .map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
        </Dropdown>
      </Stack>
      <MUIPagination
        disabled={pageCount === 1}
        color="primary"
        count={pageCount}
        page={page}
        className="pagination-main"
        onChange={(event, value) => onPageChange(value)}
        renderItem={(props) => (
          <PaginationItem
            components={{
              next: () => <div className="MuiPaginationItem-previousNext">Next</div>,
              previous: () => <div className="MuiPaginationItem-previousNext">Prev</div>,
            }}
            {...props}
          />
        )}
      />
    </Stack>
  );
};

export default Pagination;
